import React from 'react';

import { CoreExercise } from '@ts-core/modules/exercises/types';

import MultipleChoiceExerciseInput from 'modules/multipleChoiceExercises/components/MultipleChoiceExerciseInput';
import { MultipleChoiceExercise } from 'modules/multipleChoiceExercises/types';

import FillInTheBlanksExerciseInput from 'modules/fillInTheBlanksExercises/components/FillInTheBlanksExerciseInput';
import { FillInTheBlanksExercise } from 'modules/fillInTheBlanksExercises/types';

interface ExerciseHandlerProps {
  exercise: CoreExercise;
  onSelectOption: (option: any, questionId: string) => void;
  selectedOptions: Record<string, any>;
}

const ExerciseHandler = (props: ExerciseHandlerProps) => {
  const { exercise, onSelectOption, selectedOptions } = props;

  if (exercise.type === 'FillInTheBlanksExercise') {
    return (
      <FillInTheBlanksExerciseInput
        exercise={exercise as FillInTheBlanksExercise}
        onSelectOption={onSelectOption}
        selectedOptions={selectedOptions}
      />
    );
  }

  return (
    <MultipleChoiceExerciseInput exercise={exercise as MultipleChoiceExercise} onSelectOption={onSelectOption} selectedOptions={selectedOptions} />
  );
};

export default ExerciseHandler;
